import { useMemo } from 'react'
import { Outlet, useLocation, useParams } from 'react-router'
import { useTeam, useTeamPlayersOptional } from './api'
import { usePlayerDetailsOptional } from '../players/api'
import { Page } from '../widgets/Page'
import TeamHeader from './components/TeamHeader'
import Tabs from '../stories/Tabs/Tabs'
import RowContainer from '../stories/RowContainer/RowContainer'
import classes from './Teams.module.css'
import { useCompetitionId } from '../common/hooks'
import { useCompetitionDetails } from '../navigation/api'

export default function TeamDetails() {
  const { competitionId, teamId } = useParams()
  const location = useLocation()
  const competition_id = useCompetitionId()
  const { data: competitionDetails } = useCompetitionDetails({
    competition_id: competition_id,
  })

  const { data: team } = useTeam({
    competition_id: Number(competitionId),
    team_id: Number(teamId),
  })

  const isSinglePlayerTeam = competitionDetails?.single_player_teams ?? false

  const { data: teamPlayers } = useTeamPlayersOptional({
    competition_id: Number(competitionId),
    team_id: Number(teamId),
    enabled: isSinglePlayerTeam,
  })

  const singlePlayerId =
    isSinglePlayerTeam && teamPlayers && teamPlayers.length > 0
      ? teamPlayers[0].player_id
      : null

  const { data: singlePlayer } = usePlayerDetailsOptional({
    competition_id: Number(competitionId),
    player_id: singlePlayerId ?? 0,
    enabled: isSinglePlayerTeam && singlePlayerId !== null,
  })

  const activeTab = useMemo(() => {
    const path = location.pathname
      .split('/teams/')[1]
      ?.split('/')
      .slice(1)
      .join('/')
    return path ?? ''
  }, [location.pathname])

  const tabs = useMemo(() => {
    const baseTabs = [{ value: 'overview', label: 'Overview' }]
    if (competitionDetails?.kind === 'match') {
      baseTabs.push({
        value: 'matches',
        label: 'Matches',
      })
    } else {
      baseTabs.push({
        value: 'races',
        label: 'Races',
      })
    }
    if (!competitionDetails?.single_player_teams)
      baseTabs.push({ value: 'players', label: 'Players' })

    return baseTabs
  }, [competitionDetails])

  return (
    <Page
      path={'/competitions/teams'}
      context={{
        subject_type: 'team',
        subject: Number(teamId || 1),
        competition_id: competition_id,
      }}
    >
      <div className={classes.container}>
        <TeamHeader
          team_name={team.name}
          team_location={team.location}
          team_logo={team.logo.main}
          competitionKind={competitionDetails?.kind}
          singlePlayerTeams={isSinglePlayerTeam}
          singlePlayer={singlePlayer}
        />
        <div className={classes.data_wrapper}>
          <RowContainer isTransparent>
            <Tabs
              items={tabs}
              value={activeTab}
              onChange={() => {}}
              isLink
              isLarge
            />
          </RowContainer>
          <div className={classes.data_container}>
            <Outlet />
          </div>
        </div>
      </div>
    </Page>
  )
}
